var map = {
	"./1.json": [
		1754,
		1754
	],
	"./10.json": [
		2281,
		4662
	],
	"./11.json": [
		4449,
		4449
	],
	"./12.json": [
		4,
		4
	],
	"./13.json": [
		4951,
		4951
	],
	"./14.json": [
		8682,
		8682
	],
	"./15.json": [
		2309,
		2309
	],
	"./16.json": [
		136,
		136
	],
	"./17.json": [
		1547,
		1547
	],
	"./18.json": [
		7758,
		7758
	],
	"./19.json": [
		1945,
		1945
	],
	"./2.json": [
		1243,
		1243
	],
	"./20.json": [
		3677,
		3677
	],
	"./3.json": [
		7352,
		7352
	],
	"./4.json": [
		9041,
		9041
	],
	"./5.json": [
		438,
		438
	],
	"./6.json": [
		7447,
		7447
	],
	"./7.json": [
		9412,
		9412
	],
	"./8.json": [
		6141,
		6141
	],
	"./9.json": [
		4690,
		4690
	],
	"./A.json": [
		9738,
		9738
	],
	"./B.json": [
		6667,
		6667
	],
	"./C.json": [
		4152,
		4152
	],
	"./D.json": [
		7809,
		7809
	],
	"./E.json": [
		4230,
		4230
	],
	"./F.json": [
		71,
		71
	],
	"./G.json": [
		9348,
		6967
	],
	"./H.json": [
		6589,
		6589
	],
	"./I.json": [
		9906,
		9906
	],
	"./J.json": [
		8595,
		8595
	],
	"./K.json": [
		1072,
		1072
	],
	"./L.json": [
		985,
		985
	],
	"./M.json": [
		2878,
		2878
	],
	"./N.json": [
		6671,
		6671
	],
	"./O.json": [
		1308,
		1308
	],
	"./P.json": [
		9525,
		9525
	],
	"./Q.json": [
		2650,
		2650
	],
	"./R.json": [
		4011,
		4011
	],
	"./S.json": [
		4664,
		4664
	],
	"./T.json": [
		8897,
		8897
	],
	"./U.json": [
		7446,
		7446
	],
	"./V.json": [
		9639,
		9639
	],
	"./W.json": [
		1332,
		1332
	],
	"./X.json": [
		7757,
		7757
	],
	"./Y.json": [
		6354,
		6354
	],
	"./Z.json": [
		1331,
		1331
	],
	"./again.json": [
		7349,
		7349
	],
	"./ambulance.json": [
		1555,
		1555
	],
	"./and.json": [
		6967,
		9348
	],
	"./angry.json": [
		9356,
		9356
	],
	"./animal.json": [
		8039,
		8039
	],
	"./apple.json": [
		829,
		829
	],
	"./aunt.json": [
		9483,
		9483
	],
	"./autumn.json": [
		2673,
		2673
	],
	"./bird.json": [
		7576,
		5195
	],
	"./black.json": [
		2654,
		2654
	],
	"./blue.json": [
		2615,
		2615
	],
	"./boy.json": [
		8927,
		8927
	],
	"./brother.json": [
		679,
		679
	],
	"./brown.json": [
		4225,
		4225
	],
	"./candy.json": [
		7832,
		7832
	],
	"./car.json": [
		4635,
		4635
	],
	"./cat.json": [
		2433,
		2433
	],
	"./cereal.json": [
		8515,
		8515
	],
	"./chair.json": [
		1420,
		1420
	],
	"./child.json": [
		4259,
		4259
	],
	"./cold.json": [
		9545,
		9545
	],
	"./coldWeather.json": [
		1315,
		1315
	],
	"./come.json": [
		3663,
		3663
	],
	"./computer.json": [
		3606,
		3606
	],
	"./cool.json": [
		4226,
		4226
	],
	"./cow.json": [
		274,
		274
	],
	"./cry.json": [
		2785,
		2785
	],
	"./cup.json": [
		7849,
		7849
	],
	"./dog.json": [
		5675,
		5675
	],
	"./drink.json": [
		5615,
		5615
	],
	"./drinkWater.json": [
		3698,
		3698
	],
	"./drive.json": [
		6893,
		6893
	],
	"./eat.json": [
		3223,
		3223
	],
	"./eatApple.json": [
		6201,
		6201
	],
	"./eggs.json": [
		1709,
		1709
	],
	"./father.json": [
		1405,
		1405
	],
	"./feel.json": [
		7279,
		7279
	],
	"./fish.json": [
		8029,
		8029
	],
	"./freeze.json": [
		748,
		748
	],
	"./friday.json": [
		7800,
		7800
	],
	"./full.json": [
		2794,
		2794
	],
	"./future.json": [
		916,
		916
	],
	"./girl.json": [
		469,
		469
	],
	"./give.json": [
		8726,
		8726
	],
	"./go.json": [
		3821,
		3821
	],
	"./goSleep.json": [
		7748,
		7748
	],
	"./gold.json": [
		7781,
		7781
	],
	"./goodbye.json": [
		1294,
		1294
	],
	"./grandma.json": [
		4597,
		4597
	],
	"./grandpa.json": [
		9872,
		9872
	],
	"./green.json": [
		9438,
		9438
	],
	"./happy.json": [
		7379,
		7379
	],
	"./hat.json": [
		3396,
		3396
	],
	"./hate.json": [
		4411,
		4411
	],
	"./hello.json": [
		5197,
		5197
	],
	"./helloMyName.json": [
		9588,
		9588
	],
	"./horse.json": [
		9372,
		9372
	],
	"./hot.json": [
		4950,
		4950
	],
	"./hotWeather.json": [
		286,
		286
	],
	"./hungry.json": [
		5042,
		5042
	],
	"./iLoveYou.json": [
		5325,
		5325
	],
	"./juice.json": [
		3085,
		3085
	],
	"./lights.json": [
		3590,
		3590
	],
	"./like.json": [
		3888,
		3888
	],
	"./love.json": [
		7639,
		7639
	],
	"./me.json": [
		4473,
		4473
	],
	"./meHappy.json": [
		9733,
		9733
	],
	"./meHungry.json": [
		7956,
		7956
	],
	"./meSad.json": [
		4855,
		4855
	],
	"./meUnderstand.json": [
		2427,
		2427
	],
	"./meet.json": [
		8972,
		8972
	],
	"./milk.json": [
		1220,
		1220
	],
	"./monday.json": [
		2391,
		2391
	],
	"./mother.json": [
		9528,
		9528
	],
	"./my.json": [
		997,
		997
	],
	"./myBrotherAndSister.json": [
		1398,
		1398
	],
	"./myFather.json": [
		3751,
		3751
	],
	"./myMother.json": [
		9298,
		9298
	],
	"./myPetDog.json": [
		4344,
		4344
	],
	"./name.json": [
		8832,
		8832
	],
	"./nice.json": [
		4382,
		4382
	],
	"./niceToMeetYou.json": [
		563,
		563
	],
	"./now.json": [
		8377,
		8377
	],
	"./oclock.json": [
		2590,
		2590
	],
	"./orange.json": [
		3101,
		3101
	],
	"./pet.json": [
		1912,
		1912
	],
	"./pink.json": [
		2283,
		2283
	],
	"./pizza.json": [
		5047,
		5047
	],
	"./popcorn.json": [
		6968,
		6968
	],
	"./purple.json": [
		3757,
		3757
	],
	"./rain.json": [
		4645,
		4645
	],
	"./red.json": [
		4910,
		4910
	],
	"./sad.json": [
		9905,
		9905
	],
	"./saturday.json": [
		4484,
		4484
	],
	"./see.json": [
		1474,
		1474
	],
	"./seeYouTomorrow.json": [
		4870,
		4870
	],
	"./shower.json": [
		4893,
		4893
	],
	"./siblings.json": [
		1024,
		1024
	],
	"./silver.json": [
		8254,
		8254
	],
	"./sister.json": [
		7043,
		7043
	],
	"./sit.json": [
		3321,
		3321
	],
	"./sleep.json": [
		3106,
		3106
	],
	"./snow.json": [
		9680,
		9680
	],
	"./sorry.json": [
		20,
		20
	],
	"./soup.json": [
		5195,
		7576
	],
	"./spring.json": [
		8926,
		8926
	],
	"./stand.json": [
		7817,
		7817
	],
	"./stay.json": [
		6182,
		6182
	],
	"./summer.json": [
		3070,
		3070
	],
	"./sun.json": [
		4875,
		4875
	],
	"./sunday.json": [
		4655,
		4655
	],
	"./sunrise.json": [
		642,
		642
	],
	"./table.json": [
		4465,
		4465
	],
	"./talk.json": [
		5637,
		5637
	],
	"./tell.json": [
		8840,
		8840
	],
	"./this.json": [
		6931,
		6931
	],
	"./thursday.json": [
		8953,
		8953
	],
	"./today.json": [
		4756,
		4756
	],
	"./tomorrow.json": [
		2252,
		2252
	],
	"./tuesday.json": [
		7042,
		7042
	],
	"./uncle.json": [
		4774,
		4774
	],
	"./understand.json": [
		6989,
		6989
	],
	"./walk.json": [
		9274,
		9274
	],
	"./warm.json": [
		1797,
		4178
	],
	"./watch.json": [
		7086,
		7086
	],
	"./water.json": [
		5990,
		5990
	],
	"./weather.json": [
		1705,
		1705
	],
	"./wednesday.json": [
		2881,
		2881
	],
	"./when.json": [
		4255,
		4255
	],
	"./which.json": [
		5804,
		5804
	],
	"./white.json": [
		340,
		340
	],
	"./who.json": [
		6005,
		6005
	],
	"./why.json": [
		5111,
		5111
	],
	"./wind.json": [
		7209,
		7209
	],
	"./window.json": [
		6019,
		6019
	],
	"./winter.json": [
		1218,
		1218
	],
	"./year.json": [
		3002,
		3002
	],
	"./yellow.json": [
		3655,
		3655
	],
	"./yesterday.json": [
		9397,
		9397
	],
	"./you.json": [
		3214,
		3214
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4414;
module.exports = webpackAsyncContext;